<template>
    <button 
        v-if="background"
        type="button" 
        class="fac-btn" 
        :class="[design, {loading: loading}]" 
        :disabled="disabled"
        :style="{'background-color': background, 'color': classeTexto }"
		:data-ui="dataUi || null"
        @click="callback($event)"
    >
        <!-- @slot Utilize para inserir o texto do botão -->
        <slot />
    </button>
    <button 
        v-else
        type="button" 
        class="fac-btn" 
        :class="[design, {loading: loading}]" 
        :disabled="disabled"
		:data-ui="dataUi || null"
        @click="callback($event)" 
    >
        <!-- @slot Utilize para inserir o texto do botão -->
        <slot />
    </button>
</template>

<script>
	/**
	 * Componente para criar botões
	 * @displayName ui-button 
	 */
	export default {
		name: 'ui-button',
		props: {
			/**
			 * Utilize para aplicar as classes do botão 
			 */
			design: {
				type: String,
				required: false,
				default: 'primary md'
			},
			/**
			 * Utilize para aplicar o estado de loading no botão
			 */
			loading: {
				type: Boolean,
				required: false,
				default: false
			},
			/**
			 * Utilize para aplicar o estado de desativado no botão
			 */
			disabled: {
				type: Boolean,
				required: false,
				default: false
			},
			background: {
				type: String,
				default: '',
			},
			/**
			 * Define uma tag de teste para os testes integrados do botão
			 */
			 dataUi: {
				type: String,
				required: false,
				default: ''
			},
		},
		computed: {
			brilho() {
				const cor = this.background.replace('#', '');
				const r = parseInt(cor.substring(0, 2), 16);
				const g = parseInt(cor.substring(2, 4), 16);
				const b = parseInt(cor.substring(4, 6), 16);

				return Math.sqrt(
					0.299 * (r * r) +
					0.587 * (g * g) +
					0.114 * (b * b)
				);
			},
			classeTexto() {
				const limiteTomEscuro = 128
				return this.brilho < limiteTomEscuro ? '#fff' : ''
			},
      	},
		methods: {
			callback: function(e) {
				this.$emit('click', e);
			}
		},
	}
</script>	

<style lang="stylus" scoped>
	@import './styles.styl';
</style>



